import { PublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Link } from "react-router-dom";
import { $sky60 } from "../../../cssjs/colors";
import AADRoleEnum from "../../../enum/AADRoleEnum";
import PageEnum from "../../../enum/PageEnum";
import { isInTeams } from "../../../utils/common/CommonHelperFunctions";
import { AccessDenied } from "../access-denied/AccessDenied";

export interface IAuthZProps {
  roles: AADRoleEnum[];
  airportCode?: string;
  children?: React.ReactElement;
}

export const AuthZ: React.FunctionComponent<IAuthZProps> = (
  props: IAuthZProps
) => {
  const msalInstance = useMsal().instance as PublicClientApplication;
  const userRoles = msalInstance?.getAllAccounts()[0]?.idTokenClaims?.roles;
  const isAdmin = location?.pathname?.startsWith("/admin");
  const isApplicationSettings = location?.pathname?.startsWith(
    "/application-settings"
  );
  const isInTeamsContext = isInTeams();

  const isAuthorizedUser = props.roles?.every((role) =>
    userRoles?.includes(role.toString())
  );

  return isAuthorizedUser ? (
    <div>{props.children}</div>
  ) : (
    <>
      <AccessDenied />{" "}
      {isApplicationSettings && isInTeamsContext && (
        <section
          className="amd-section-shadow my-4"
          data-testid="accessDeniedContainer"
        >
          {" "}
          <Link
            to={`/${
              PageEnum.PageUrl.ApplicationSettings
            }?airport=${encodeURIComponent(props.airportCode || "")}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: `${$sky60}`,
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Open in web view to access.
          </Link>
        </section>
      )}
      {isAdmin && isInTeamsContext && (
        <section
          className="amd-section-shadow my-4"
          data-testid="accessDeniedContainer"
        >
          {" "}
          <Link
            to={`/${PageEnum.PageUrl.Admin}?airport=${encodeURIComponent(
              props.airportCode || ""
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: `${$sky60}`,
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Open in web view to access.
          </Link>
        </section>
      )}
    </>
  );
};
